export const SESSION_NOTICE_KEY = 'sessionEndMessage';

export async function rememberSessionEnd(response) {
  let data = {};
  try {
    data = await (response.clone ? response.clone() : response).json();
  } catch (_) {
    // A missing or already consumed error body must not prevent signing out.
  }
  const detail = typeof data?.detail === 'string' ? data.detail : '';
  const message = detail.includes('другого')
    ? 'Под этим логином выполнен вход с другого устройства или окна. Для одновременной работы используйте отдельные учётные записи. Войдите снова под своим логином.'
    : 'Сессия завершена. Войдите снова, чтобы продолжить работу.';
  sessionStorage.setItem(SESSION_NOTICE_KEY, message);
}

export async function expireSession(response) {
  await rememberSessionEnd(response);
  ['token', 'userId', 'userRole', 'companyId', 'onboardingStatus'].forEach(key => localStorage.removeItem(key));
  window.location.reload();
}
